import { isYesterday, isTomorrow, isToday, format } from 'date-fns'
import * as React from 'react'

interface Props {
  date: number
  hours?: boolean
  explain?: boolean
}

const DateFormat = ({ date, hours, explain }: Props) => {
  try {
    if (explain && isYesterday(date)) return <>Yesterday</>
    if (explain && isTomorrow(date)) return <>Tomorrow</>
    if (explain && isToday(date)) return <>Today</>

    return <>{format(date, hours ? 'PPPp' : 'PPP')}</>
  } catch (e) {
    return <>Undefined Date</>
  }
}

export default DateFormat
